module.exports = __webpack_public_path__ + "static/media/TB-ver-inv-web125.3f2b67f4.png";